module.exports = __webpack_public_path__ + "img/img-331868.png";